/**
 * HTTP service for the analytics feature (PX-W6.4): the two project analytics
 * endpoints of `AnalyticsController` (`server/conf/routes`, verified
 * 2026-09-04). No money, no side cut — identical figures for a firm-side and
 * a client-side reader.
 */

import { apiClient } from '@/services'

import type { GateCycleTimeSummary, VelocityResponse } from '../types'

export const analyticsServiceHttp = {
  /** Gate cycle times (`GET …/analytics/cycle-time`). */
  cycleTime(projectId: string): Promise<GateCycleTimeSummary> {
    return apiClient.get<GateCycleTimeSummary>(`/{orgId}/projects/${projectId}/analytics/cycle-time`)
  },

  /** Delivery velocity (`GET …/analytics/velocity`) — `available:false` until Wave 4. */
  velocity(projectId: string): Promise<VelocityResponse> {
    return apiClient.get<VelocityResponse>(`/{orgId}/projects/${projectId}/analytics/velocity`)
  }
}
